import { DownOutlined, } from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";
import React from "react";

const items = [
    { label: <a href="https://www.google.com" target="_blank" rel="noreferrer">1st menu item</a>, key: "0" },
    { label: <a href="https://www.google.com" target="_blank" rel="noreferrer">2nd menu item</a>, key: "1" },
    { type: "divider" },
    { label: <a href="https://www.google.com" target="_blank" rel="noreferrer">3rd menu item</a>, key: "2" }
];
const menuProps = {
    items
};

export const StyledDropDownSHB = () => {
    return (
        <>
            <div className="mt-4">
                <Space>
                    <Dropdown menu={{ items }} trigger={["click"]} >
                        <a onClick={(e) => e.preventDefault()}>
                            <Space>
                                Click me
                                <DownOutlined />
                            </Space>
                        </a>
                    </Dropdown>

                    <Dropdown menu={{ items }}>
                        <a onClick={(e) => e.preventDefault()}>
                            <Space>
                                Hover me
                                <DownOutlined />
                            </Space>
                        </a>
                    </Dropdown>

                    <Dropdown menu={menuProps}>
                        <Button>
                            <Space>
                                Button
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>
                </Space>
            </div>
        </>
    )
}